
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparCube as ObiBuoySparCubeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-cube.js';
 
 
 

 
 export const ObiBuoySparCube = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-cube',
   elementClass: ObiBuoySparCubeElement,
   events: {
     
   }
  });
 
 